import React from 'react';

import Slyce360LogoOriginal from './Slyce360Logo_Original';

const Slyce360Logo = (props) => {
	return <Slyce360LogoOriginal />;
};

export default Slyce360Logo;
